import { Member, GenderCode } from '../members/members.types';
import { Program } from '../programs/Types';

export type AttendanceActionTypes =
  'GET_ATTENDANCE' | 'GET_ATTENDANCE_PENDING' | 'GET_ATTENDANCE_FULFILLED' | 'GET_ATTENDANCE_REJECTED' |
  'UPDATE_ATTENDANCE_AFTER_CHECKIN' |
  'REVERT_TO_INITIAL_STATE' | 'REVERT_TO_INITIAL_STATE_EXCEPT_AUTH';

export type AttendanceState = {
  readonly statusCode: number
  readonly attendance?: AttendanceEntity
};

export type Attendance = {
  readonly memberId: string
  readonly name: string
  readonly attendanceDetails: AttendanceDetails
  readonly tags: string[]
  readonly programNames: string[]
  readonly picUrl: string
  readonly phone: string
  readonly gender: GenderCode
  readonly programId?: number
};

export type AttendanceDetail = {
  readonly memberId: string
  readonly time: number
  readonly programId: number
  readonly packageId: number
  readonly noShow: boolean
};

export type AttendanceDetails = {
  readonly 1?: AttendanceDetail[]
  readonly 2?: AttendanceDetail[]
  readonly 3?: AttendanceDetail[]
  readonly 4?: AttendanceDetail[]
  readonly 5?: AttendanceDetail[]
  readonly 6?: AttendanceDetail[]
  readonly 7?: AttendanceDetail[]
  readonly 8?: AttendanceDetail[]
  readonly 9?: AttendanceDetail[]
  readonly 10?: AttendanceDetail[]
  readonly 11?: AttendanceDetail[]
  readonly 12?: AttendanceDetail[]
  readonly 13?: AttendanceDetail[]
  readonly 14?: AttendanceDetail[]
  readonly 15?: AttendanceDetail[]
  readonly 16?: AttendanceDetail[]
  readonly 17?: AttendanceDetail[]
  readonly 18?: AttendanceDetail[]
  readonly 19?: AttendanceDetail[]
  readonly 20?: AttendanceDetail[]
  readonly 21?: AttendanceDetail[]
  readonly 22?: AttendanceDetail[]
  readonly 23?: AttendanceDetail[]
  readonly 24?: AttendanceDetail[]
  readonly 25?: AttendanceDetail[]
  readonly 26?: AttendanceDetail[]
  readonly 27?: AttendanceDetail[]
  readonly 28?: AttendanceDetail[]
  readonly 29?: AttendanceDetail[]
  readonly 30?: AttendanceDetail[]
  readonly 31?: AttendanceDetail[]
};

export type AttendanceEntity = {
  readonly msg: string
  readonly attendances: Attendance[]
};

export const  initialAttendanceState = {
  statusCode: 0,
  attendance: undefined
};

export type CheckinActionTypes =
'CHECKIN' | 'CHECKIN_PENDING' | 'CHECKIN_FULFILLED' | 'CHECKIN_REJECTED' |
'UNCHECKIN' | 'UNCHECKIN_PENDING' | 'UNCHECKIN_FULFILLED' | 'UNCHECKIN_REJECTED' |
'REVERT_TO_INITIAL_STATE' | 'REVERT_TO_INITIAL_STATE_EXCEPT_AUTH' |
'ANTI_IDLE';

export interface CheckinState {
  readonly statusCode: number;
  readonly msg: string;
  readonly entity?: CheckinMember;
  readonly entityMemberId?: number;
}

export interface CheckinEntity {
  readonly msg: string;
  readonly entity?: CheckinMember;
  readonly memberId?: number;
}

export interface CheckinMember {
  id: number;
  member: Member;
  time: number;
  invalidAttendance: boolean;
  msg: string;
  program?: Program;
  noShow?: boolean;
}

export const  initialCheckinState = {
  statusCode: 0,
  msg: '',
  entity: undefined
};

export type FilterOption = 'Name' | 'Program' | 'Tag';


// WEBPACK FOOTER //
// ./src/attendance/attendance.types.tsx